var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScrollToTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF0F4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Group_7856",
    transform: "translate(-1366 -1139)",
    className: "st0",
    d: "M1370,1143h16v-2h-16V1143z M1370,1153 l1.4100342,1.4100342L1377,1148.8299561V1161h2v-12.1700439l5.5799561,5.5900879L1386,1153l-8-8L1370,1153z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScrollToTop);
export default __webpack_public_path__ + "static/media/Icon_ScrollToTop.e23db0b5c9f8a63125c6a6ad84fa81ad.svg";
export { ForwardRef as ReactComponent };